import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ApiResponse } from "@/utils/ApiResponse";
import { MarcaVehiculoInterface } from "../../interfaces/marcaVehiculosInterfaces/MarcaVehiculo.interface";
import { useToast } from "vue-toastification";
import { MarcaVehiculoCreateAction } from "../../actions/marcaVehiculosActions";

const toast = useToast();

export function useMarcaVehiculoCreate(onClose?: () => void) {
  const queryClient = useQueryClient();

  // Mutation para crear la marca de vehÃ­culo
  const mutation = useMutation({
    mutationFn: (formData: FormData) =>
      MarcaVehiculoCreateAction(formData),

    onSuccess:async (response: ApiResponse<MarcaVehiculoInterface>) => {
      await queryClient.invalidateQueries({ queryKey: ["MarcaVehiculosList"] });
     await queryClient.refetchQueries({
        queryKey: ["MarcaModeloList"],
        exact: true,
      });
      toast.success("Marca de vehÃ­culo creada correctamente");
       if (onClose) onClose();
    },

    onError: (error: unknown) => {
      toast.error("Error al crear marca de vehÃ­culo");
        if (onClose) onClose();
    },
  });

  return {
    ...mutation, // => { mutate, mutateAsync, isPending, isError, error, isSuccess, data }
  };
}
